















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<SuggestionsSubNav>({
    components: { }
})
export default class SuggestionsSubNav extends Vue {
    @Prop({type: Boolean, default: false}) public inDashboard ?: boolean

    public get currentPath() {
        return this.$route.path.replace(/\/(recent|popular|actioned)/gi, '').replace(/[\/]+$/g, '')
    }

    public get activeMode() {
        return this.$route.params.mode || 'recent'
    }

    public get navMap() {
        return [
            { label: 'Most Recent', mode: 'recent' },
            { label: 'Popular', mode: 'popular' },
            { label: 'Reviewed', mode: 'actioned' }
        ]
    }
}
